import ReservationsCalendarPage from '../app/pages/ReservationsCalendarPage';
import AddReservationPage from '../app/pages/AddReservation';
import PlaceMapViewPage from '../app/pages/PlaceMapViewPage';
import ReservationSettingsPage from '../app/pages/ReservationSettings';
import FindReservationPage from 'app/pages/FindReservationPage';
import { IRoute } from './types';
import ReservationCustomersPage from 'app/pages/ReservationCustomersPage';
import { OTO_PRODUCTS, ROLES } from 'enums';

export const reservationListRoute: IRoute = {
  name: 'Lista rezerwacji',
  path: '/calendar',
  component: ReservationsCalendarPage,
};

export const addReservationRoute: IRoute = {
  name: 'Dodaj rezerwację',
  path: '/add-reservation/',
  component: AddReservationPage,
};

export const addReservationWithDateRoute: IRoute = {
  name: 'Dodaj rezerwację',
  path: '/add-reservation/:date',
  component: AddReservationPage,
};

export const addReservationWithDateAndTableRoute: IRoute = {
  name: 'Dodaj rezerwację',
  path: '/add-reservation/:date/:tableId',
  component: AddReservationPage,
};

export const placeMapViewRoute: IRoute = {
  name: 'Mapa stolików',
  path: '/place-map-view',
  component: PlaceMapViewPage,
};

export const findReservationRoute: IRoute = {
  name: 'Znajdź rezerwację',
  path: '/find-reservation',
  component: FindReservationPage,
};

export const reservationCustomersRoute: IRoute = {
  name: 'Lista klientów',
  path: '/reservation-customers',
  component: ReservationCustomersPage,
  availableWithProducts: [OTO_PRODUCTS.reservation_customers],
};

export const reservationSettingsRoute: IRoute = {
  name: 'Ustawienia rezerwacji',
  path: '/settings/reservations',
  // @ts-ignore todo fix props
  component: ReservationSettingsPage,
  availableForRoles: [ROLES.ADMIN, ROLES.RESTAURANT_ADMIN],
  availableWithProducts: [OTO_PRODUCTS.reservations, OTO_PRODUCTS.call_waiter],
};
